export default "__VITE_ASSET__BCWEjwoA__"